import EventManagerFooter from 'components/wrapperEventManager/eventManagerFooter.component';
import { useVisualisationEventManager } from '../hooks/useVisualisationEventManager.hooks';
import VisualisationEventManagerBody from './visualisationEventManagerBody.component';
import VisualisationEventManagerHeader from './visualisationEventManagerHeader.component';


function VisualisationEventManager() {

  const { selectedEventManager, sector, interval } = useVisualisationEventManager();

  return (
    <>
      {
        selectedEventManager != null && (
          <div className='relative flex flex-col w-screen h-screen bg-sky-100/80 text-black overflow-hidden'>
            <VisualisationEventManagerHeader sector={ sector } eventManager={ selectedEventManager }/>
            <div className='flex h-full w-full pb-36'>
              <VisualisationEventManagerBody duration={ interval } eventManager={ selectedEventManager }/>
            </div>
            <EventManagerFooter themes={ selectedEventManager.themes }/>
          </div>
        )
      }
    </>
  );
}

export default VisualisationEventManager;
